import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';

// ATL-1512: generated from the backend (`client-operations` module), per the data-transformation
// architecture — the hand-written snake_case shapes this file used to hold described a route that
// never existed.
const {
  ClientOperationFirestoreResponse: ClientOperationResponseDtoGenerated,
  CreateClientOperationDto: CreateClientOperationDtoGenerated,
  LegacyClientOperationResponse: LegacyClientOperationResponseGenerated,
} = schemas;

export const ClientOperationResponseSchema = ClientOperationResponseDtoGenerated;
export const CreateClientOperationSchema = CreateClientOperationDtoGenerated;
export const LegacyClientOperationResponseSchema = LegacyClientOperationResponseGenerated;

export type ClientOperationResponse = z.infer<typeof ClientOperationResponseSchema>;
export type CreateClientOperation = z.infer<typeof CreateClientOperationSchema>;
export type LegacyClientOperationResponse = z.infer<typeof LegacyClientOperationResponseSchema>;

export function createClientOperationsApi(client: TypedApiClient) {
  return {
    /** One page of a client's operations, newest first (limit ≤ 1000). */
    getClientOperations: (params: {
      clientId: string;
      limit?: number;
      offset?: number;
    }): Promise<ClientOperationResponse[]> => {
      return client.get('/client-operations', {
        params: params as Record<string, unknown>,
        responseSchema: z.array(ClientOperationResponseSchema),
      });
    },

    /**
     * LEGACY — records an unkeyed manual bonus change as history (never changes the balance). Only
     * bundles from before ATL-1445 stage 2c call it; a current bundle mirrors the change through
     * `POST /clients/:id/bonus-adjustments`.
     */
    createClientOperation: (
      data: CreateClientOperation,
    ): Promise<LegacyClientOperationResponse> => {
      return client.post('/client-operations', {
        data: CreateClientOperationSchema.parse(data),
        responseSchema: LegacyClientOperationResponseSchema,
      });
    },
  };
}
